module.exports = __webpack_public_path__ + "img/abIcon.ce3a1a7.png";